 new WheelCarousel('{{ "introduction4-sticky-box-" | append : flag }}', '{{ "introduction4-sticky-" | append : flag }}', '{{ "introduction4-wheel-carousel-" | append : flag }}',0.2)

    new Swiper('{{ "#introduction4-swiper-mobile-" | append : flag }}', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        centeredSlides : true,
        pagination: {
            el: '{{ "#introduction4-swiper-pagination-mobile-" | append : flag }}',
            renderBullet: function (index, className) {
                return '<span class="' + className + '"> </span>';
            },
        },
        on: {

        },
    });

    setSwiperContentHeight('introduction-pic-mobile');
    setSwiperContentHeight('introduction-h1-mobile');
    setSwiperContentHeight('introduction-h2-mobile');

    $(window).on('resize', function () {
        setSwiperContentHeight('introduction-pic-mobile');
        setSwiperContentHeight('introduction-h1-mobile');
        setSwiperContentHeight('introduction-h2-mobile');
    })
